module.exports = __webpack_public_path__ + "ed242ead2b178f6c1e36bd327fb6f100.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/3.png
// module id = 33
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18